import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Alert,
  Snackbar,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  Tabs,
  Tab,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Tooltip,
  Fade,
  Zoom,
  Slide,
  Grow,
  useTheme,
  alpha,
  LinearProgress,
  Avatar,
  Badge,
  CardActionArea,
  CardActions,
  CardMedia,
  Stack,
  Skeleton,
  Fab,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Backdrop,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Radio,
  RadioGroup,
  FormLabel,
  Checkbox,
  Slider,
  Rating,
  ToggleButton,
  ToggleButtonGroup,
  AlertTitle,
  Breadcrumbs,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Autocomplete,
  InputAdornment,
  OutlinedInput,
  InputBase,
  Popper,
  Menu,
  ListItemButton,
  ListItemAvatar,
  Collapse,
  AccordionActions,
  useMediaQuery,
  useScrollTrigger,
  AppBar,
  Toolbar,
  Drawer,
  ListSubheader,
  Divider as MuiDivider,
  Box as MuiBox
} from '@mui/material';
import {
  Notifications as NotificationsIcon,
  Analytics as AnalyticsIcon,
  Campaign as CampaignIcon,
  Schedule as ScheduleIcon,
  Person as PersonIcon,
  TrendingUp as TrendingUpIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  ExpandMore as ExpandMoreIcon,
  Send as SendIcon,
  Refresh as RefreshIcon,
  Settings as SettingsIcon,
  Psychology as PsychologyIcon,
  AutoAwesome as AutoAwesomeIcon,
  RocketLaunch as RocketLaunchIcon,
  Science as ScienceIcon,
  Insights as InsightsIcon,
  Timeline as TimelineIcon,
  TrendingDown as TrendingDownIcon,
  AccountBalance as AccountBalanceIcon,
  VerifiedUser as VerifiedUserIcon,
  People as GroupIcon,
  Timeline as ActivityIcon,
  ScheduleSend as ScheduleSendIcon,
  CampaignOutlined as CampaignOutlinedIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  MoreVert as MoreVertIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Share as ShareIcon,
  Print as PrintIcon,
  ContentCopy as ContentCopyIcon,
  VisibilityOff as VisibilityOffIcon,
  Lock as LockIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  TrendingFlat as TrendingFlatIcon,
  ShowChart as ShowChartIcon,
  PieChart as PieChartIcon,
  BarChart as BarChartIcon,
  ScatterPlot as ScatterPlotIcon,
  BubbleChart as BubbleChartIcon,
  DonutLarge as DonutLargeIcon,
  DonutSmall as DonutSmallIcon,
  MultilineChart as MultilineChartIcon,
  Timeline as TimelineIcon2,
  Assessment as AssessmentIcon,
  Analytics as AnalyticsIcon2,
  DataUsage as DataUsageIcon,
  Storage as StorageIcon,
  Cloud as CloudIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  Sync as SyncIcon,
  SyncDisabled as SyncDisabledIcon,
  Pause as PauseIcon,
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
  FastForward as FastForwardIcon,
  FastRewind as FastRewindIcon,
  VolumeUp as VolumeUpIcon,
  VolumeDown as VolumeDownIcon,
  VolumeOff as VolumeOffIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Palette as PaletteIcon,
  Brush as BrushIcon,
  FormatPaint as FormatPaintIcon,
  ColorLens as ColorLensIcon,
  Gradient as GradientIcon,
  Opacity as OpacityIcon,
  BlurOn as BlurOnIcon,
  BlurOff as BlurOffIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  CenterFocusWeak as CenterFocusWeakIcon,
  Crop as CropIcon,
  CropFree as CropFreeIcon,
  CropSquare as CropSquareIcon,
  Crop169 as Crop169Icon,
  Crop32 as Crop32Icon,
  Crop54 as Crop54Icon,
  Crop75 as Crop75Icon,
  CropDin as CropDinIcon,
  CropLandscape as CropLandscapeIcon,
  CropPortrait as CropPortraitIcon,
  CropRotate as CropRotateIcon,
  CropSquare as CropSquareIcon2,
  Filter1 as Filter1Icon,
  Filter2 as Filter2Icon,
  Filter3 as Filter3Icon,
  Filter4 as Filter4Icon,
  Filter5 as Filter5Icon,
  Filter6 as Filter6Icon,
  Filter7 as Filter7Icon,
  Filter8 as Filter8Icon,
  Filter9 as Filter9Icon,
  Filter9Plus as Filter9PlusIcon,
  FilterAlt as FilterAltIcon,
  FilterAltOff as FilterAltOffIcon,
  FilterBAndW as FilterBAndWIcon,
  FilterCenterFocus as FilterCenterFocusIcon,
  FilterDrama as FilterDramaIcon,
  FilterFrames as FilterFramesIcon,
  FilterHdr as FilterHdrIcon,
  FilterNone as FilterNoneIcon,
  FilterTiltShift as FilterTiltShiftIcon,
  FilterVintage as FilterVintageIcon,
  Flare as FlareIcon,
  FlashAuto as FlashAutoIcon,
  FlashOff as FlashOffIcon,
  FlashOn as FlashOnIcon,
  Flip as FlipIcon,
  FlipCameraAndroid as FlipCameraAndroidIcon,
  FlipCameraIos as FlipCameraIosIcon,
  Grain as GrainIcon,
  GridOff as GridOffIcon,
  GridOn as GridOnIcon,
  HdrOff as HdrOffIcon,
  HdrOn as HdrOnIcon,
  HdrStrong as HdrStrongIcon,
  HdrWeak as HdrWeakIcon,
  Healing as HealingIcon,
  Image as ImageIcon,
  ImageAspectRatio as ImageAspectRatioIcon,
  ImageNotSupported as ImageNotSupportedIcon,
  ImageSearch as ImageSearchIcon,
  Iso as IsoIcon,
  Landscape as LandscapeIcon,
  LeakAdd as LeakAddIcon,
  LeakRemove as LeakRemoveIcon,
  Lens as LensIcon,
  LinkedCamera as LinkedCameraIcon,
  Looks as LooksIcon,
  Looks3 as Looks3Icon,
  Looks4 as Looks4Icon,
  Looks5 as Looks5Icon,
  Looks6 as Looks6Icon,
  LooksOne as LooksOneIcon,
  LooksTwo as LooksTwoIcon,
  Loupe as LoupeIcon,
  MonochromePhotos as MonochromePhotosIcon,
  MovieCreation as MovieCreationIcon,
  MovieFilter as MovieFilterIcon,
  MusicNote as MusicNoteIcon,
  Nature as NatureIcon,
  NaturePeople as NaturePeopleIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  Palette as PaletteIcon2,
  Panorama as PanoramaIcon,
  PanoramaFishEye as PanoramaFishEyeIcon,
  PanoramaHorizontal as PanoramaHorizontalIcon,
  PanoramaVertical as PanoramaVerticalIcon,
  PanoramaWideAngle as PanoramaWideAngleIcon,
  Photo as PhotoIcon,
  PhotoAlbum as PhotoAlbumIcon,
  PhotoCamera as PhotoCameraIcon,
  PhotoFilter as PhotoFilterIcon,
  PhotoLibrary as PhotoLibraryIcon,
  PhotoSizeSelectActual as PhotoSizeSelectActualIcon,
  PhotoSizeSelectLarge as PhotoSizeSelectLargeIcon,
  PhotoSizeSelectSmall as PhotoSizeSelectSmallIcon,
  PictureAsPdf as PictureAsPdfIcon,
  Portrait as PortraitIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Rotate90DegreesCcw as Rotate90DegreesCcwIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  ShutterSpeed as ShutterSpeedIcon,
  Slideshow as SlideshowIcon,
  Straighten as StraightenIcon,
  Style as StyleIcon,
  SwitchCamera as SwitchCameraIcon,
  SwitchVideo as SwitchVideoIcon,
  TagFaces as TagFacesIcon,
  Texture as TextureIcon,
  Timelapse as TimelapseIcon,
  Timer as TimerIcon,
  Timer3 as Timer3Icon,
  Timer10 as Timer10Icon,
  TimerOff as TimerOffIcon,
  Tonality as TonalityIcon,
  Transform as TransformIcon,
  Tune as TuneIcon,
  ViewComfy as ViewComfyIcon,
  ViewCompact as ViewCompactIcon,
  Vignette as VignetteIcon,
  WbAuto as WbAutoIcon,
  WbCloudy as WbCloudyIcon,
  WbIncandescent as WbIncandescentIcon,
  WbIridescent as WbIridescentIcon,
  WbSunny as WbSunnyIcon,
  ThreeSixty as ThreeSixtyIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon
} from '@mui/icons-material';
import api from '../services/api';
import { logActivity, ActivityTypes } from '../utils/activityLogger';

const SmartNotifications = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [activeTab, setActiveTab] = useState(0);
  const [templates, setTemplates] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [campaignResults, setCampaignResults] = useState(null);
  const [userAnalysis, setUserAnalysis] = useState(null);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [customData, setCustomData] = useState({});
  const [showSpeedDial, setShowSpeedDial] = useState(false);
  const [showAdvancedModal, setShowAdvancedModal] = useState(false);
  const [showAnalyticsModal, setShowAnalyticsModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [sortBy, setSortBy] = useState('date');
  const [viewMode, setViewMode] = useState('grid');
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [analyticsData, setAnalyticsData] = useState({
    campaignPerformance: {
      totalCampaigns: 0,
      averageEngagement: 0,
      totalNotificationsSent: 0,
      successRate: 0,
      revenueGenerated: 0
    },
    userSegments: [],
    recentCampaigns: []
  });
  const [analyticsLoading, setAnalyticsLoading] = useState(false);

  // A/B Testing state
  const [abTestData, setAbTestData] = useState({
    activeTests: [],
    testResults: {},
    newTest: {
      name: '',
      variantA: { subject: '', content: '' },
      variantB: { subject: '', content: '' },
      targetSegment: 'all',
      testDuration: 7,
      successMetric: 'click_rate'
    }
  });

  // Advanced segmentation state
  const [segments, setSegments] = useState([]);
  const [segmentsLoading, setSegmentsLoading] = useState(false);

  // Template management state
  const [templateManagement, setTemplateManagement] = useState({
    showCreateModal: false,
    editingTemplate: null,
    newTemplate: {
      key: '',
      title: '',
      content: '',
      category: 'marketing',
      variables: []
    }
  });

  const [realTimeStats, setRealTimeStats] = useState({
    activeUsers: 0,
    notificationsSent: 0,
    successRate: 0,
    engagementRate: 0,
    totalUsers: 0,
    recentActivity: 0,
    lastUpdated: null
  });

  // Users list for dropdown
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [userSearchQuery, setUserSearchQuery] = useState('');

  // Real-time stats loading state
  const [realTimeStatsLoading, setRealTimeStatsLoading] = useState(false);

  // Campaign settings
  const [campaignSettings, setCampaignSettings] = useState({
    inactiveUsers: { enabled: true, limit: 100 },
    lowBalance: { enabled: true, limit: 100 },
    highValue: { enabled: true, limit: 100 },
    kycReminder: { enabled: true, limit: 100 },
    morningPromo: { enabled: true, limit: 1000 },
    eveningPromo: { enabled: true, limit: 1000 }
  });

  // Advanced campaign settings
  const [advancedSettings, setAdvancedSettings] = useState({
    aiOptimization: true,
    personalizationLevel: 3,
    timingOptimization: true,
    aBTesting: false,
    retargeting: true,
    frequencyCapping: 3,
    priorityLevel: 'medium',
    customSegments: [],
    exclusionList: [],
    performanceThreshold: 0.7
  });

  const [triggeringMeterLow, setTriggeringMeterLow] = useState(false);

  const handleTriggerMeterLow = async () => {
    setTriggeringMeterLow(true);
    try {
      const result = await api.smartNotifications.triggerMeterLow();
      setSnackbar({
        open: true,
        message: result.success ? `Meter low notifications sent to ${result.sent || 0} users.` : (result.reason || 'Failed to send notifications'),
        severity: result.success ? 'success' : 'error'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Failed to send meter low notifications',
        severity: 'error'
      });
    } finally {
      setTriggeringMeterLow(false);
    }
  };

  useEffect(() => {
    loadTemplates();
    loadUsers();
    loadAnalyticsData();
    loadSegments();
    startRealTimeUpdates();
    return () => stopRealTimeUpdates();
  }, []);

  // Real-time statistics with actual data
  const startRealTimeUpdates = () => {
    // Load initial data
    loadRealTimeStats();
    
    // Set up interval to refresh data every 30 seconds
    const interval = setInterval(() => {
      loadRealTimeStats();
    }, 30000); // 30 seconds
    
    return () => clearInterval(interval);
  };

  const stopRealTimeUpdates = () => {
    // Cleanup function
  };

  const loadRealTimeStats = async () => {
    try {
      setRealTimeStatsLoading(true);
      const response = await api.smartNotifications.getRealTimeStats();
      if (response && response.success) {
        setRealTimeStats({
          activeUsers: response.data?.activeUsers || 0,
          notificationsSent: response.data?.notificationsSent || 0,
          successRate: response.data?.successRate || 0,
          engagementRate: response.data?.engagementRate || 0,
          totalUsers: response.data?.totalUsers || 0,
          recentActivity: response.data?.recentActivity || 0,
          lastUpdated: response.data?.lastUpdated || new Date().toISOString()
        });
      } else {
        // Set default values if response is not successful
        setRealTimeStats(prev => ({
          ...prev,
          lastUpdated: new Date().toISOString()
        }));
      }
    } catch (error) {
      console.error('Error loading real-time stats:', error);
      // Set default values on error
      setRealTimeStats(prev => ({
        ...prev,
        lastUpdated: new Date().toISOString()
      }));
    } finally {
      setRealTimeStatsLoading(false);
    }
  };

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const response = await api.smartNotifications.getTemplates();
      setTemplates(response.data);
    } catch (error) {
      console.error('Error loading templates:', error);
      setSnackbar({
        open: true,
        message: 'Failed to load notification templates',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const loadUsers = async () => {
    try {
      setUsersLoading(true);
      const response = await api.dashboard.getAllUsers();
      setUsers(response || []);
    } catch (error) {
      console.error('Error loading users:', error);
      setSnackbar({
        open: true,
        message: 'Failed to load users',
        severity: 'error'
      });
    } finally {
      setUsersLoading(false);
    }
  };

  const loadAnalyticsData = async () => {
    try {
      setAnalyticsLoading(true);
      const response = await api.smartNotifications.getAnalytics();
      
      if (response && response.success) {
        setAnalyticsData({
          campaignPerformance: response.data.campaignPerformance || {
            totalCampaigns: 0,
            averageEngagement: 0,
            totalNotificationsSent: 0,
            successRate: 0,
            revenueGenerated: 0
          },
          userSegments: response.data.userSegments || [],
          recentCampaigns: response.data.recentCampaigns || []
        });
      } else {
        // Fallback to real-time stats if analytics endpoint fails
        const realTimeResponse = await api.smartNotifications.getRealTimeStats();
        if (realTimeResponse && realTimeResponse.success) {
          setAnalyticsData({
            campaignPerformance: {
              totalCampaigns: realTimeResponse.data.totalCampaigns || 0,
              averageEngagement: realTimeResponse.data.engagementRate || 0,
              totalNotificationsSent: realTimeResponse.data.notificationsSent || 0,
              successRate: realTimeResponse.data.successRate || 0,
              revenueGenerated: realTimeResponse.data.revenueGenerated || 0
            },
            userSegments: realTimeResponse.data.userSegments || [],
            recentCampaigns: realTimeResponse.data.recentCampaigns || []
          });
        }
      }
    } catch (error) {
      console.error('Error loading analytics data:', error);
      setSnackbar({
        open: true,
        message: 'Failed to load analytics data',
        severity: 'error'
      });
    } finally {
      setAnalyticsLoading(false);
    }
  };

  const loadSegments = async () => {
    try {
      setSegmentsLoading(true);
      const response = await api.smartNotifications.getSegments();
      
      if (response && response.success) {
        setSegments(response.data || []);
      } else {
        // Generate default segments if API fails
        const defaultSegments = await generateDefaultSegments();
        setSegments(defaultSegments);
      }
    } catch (error) {
      console.error('Error loading segments:', error);
      // Generate default segments on error
      const defaultSegments = await generateDefaultSegments();
      setSegments(defaultSegments);
      setSnackbar({
        open: true,
        message: 'Failed to load segments, showing default data',
        severity: 'warning'
      });
    } finally {
      setSegmentsLoading(false);
    }
  };

  const generateDefaultSegments = async () => {
    try {
      // Get real user counts from database
      const totalUsers = await api.dashboard.getTotalUsers();
      const totalBalance = await api.dashboard.getTotalBalance();
      
      // Calculate approximate segments based on available data
      const highValueCount = Math.floor(totalUsers * 0.15); // 15% high value
      const regularCount = Math.floor(totalUsers * 0.45); // 45% regular
      const inactiveCount = Math.floor(totalUsers * 0.25); // 25% inactive
      const newCount = Math.floor(totalUsers * 0.15); // 15% new

      return [
        {
          id: 1,
          name: 'High Value Customers',
          criteria: { minSpend: 50000, timeframe: 30 },
          userCount: highValueCount,
          description: 'Users who spent over ₦50,000 in the last 30 days'
        },
        {
          id: 2,
          name: 'Regular Users',
          criteria: { minSpend: 10000, maxSpend: 50000, timeframe: 30 },
          userCount: regularCount,
          description: 'Active users with moderate spending patterns'
        },
        {
          id: 3,
          name: 'Inactive Users',
          criteria: { inactiveDays: 7 },
          userCount: inactiveCount,
          description: 'Users with no activity in the last 7 days'
        },
        {
          id: 4,
          name: 'New Users',
          criteria: { registrationDays: 30 },
          userCount: newCount,
          description: 'Users who registered in the last 30 days'
        }
      ];
    } catch (error) {
      console.error('Error generating default segments:', error);
      // Return fallback segments
      return [
        {
          id: 1,
          name: 'High Value Customers',
          criteria: { minSpend: 50000, timeframe: 30 },
          userCount: 0,
          description: 'Users who spent over ₦50,000 in the last 30 days'
        },
        {
          id: 2,
          name: 'Regular Users',
          criteria: { minSpend: 10000, maxSpend: 50000, timeframe: 30 },
          userCount: 0,
          description: 'Active users with moderate spending patterns'
        },
        {
          id: 3,
          name: 'Inactive Users',
          criteria: { inactiveDays: 7 },
          userCount: 0,
          description: 'Users with no activity in the last 7 days'
        },
        {
          id: 4,
          name: 'New Users',
          criteria: { registrationDays: 30 },
          userCount: 0,
          description: 'Users who registered in the last 30 days'
        }
      ];
    }
  };

  // Filter users based on search query
  const filteredUsers = users.filter(user => {
    const searchTerm = userSearchQuery.toLowerCase();
    return (
      (user.fullname && user.fullname.toLowerCase().includes(searchTerm)) ||
      (user.phone && user.phone.toLowerCase().includes(searchTerm)) ||
      (user.email && user.email.toLowerCase().includes(searchTerm)) ||
      (user._id && user._id.toLowerCase().includes(searchTerm))
    );
  });

  const handleSnackbarClose = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const runCampaign = async (campaignType) => {
    try {
      setLoading(true);
      const response = await api.smartNotifications.runCampaign(
        campaignType, 
        campaignSettings[campaignType]?.limit || 100
      );

      setCampaignResults(response);
      
      // Log activity
      await logActivity({
        action: ActivityTypes.NOTIFICATION_CAMPAIGN,
        details: `Ran ${campaignType} smart notification campaign`,
        metadata: {
          campaignType,
          results: response.data
        }
      });

      setSnackbar({
        open: true,
        message: `${campaignType} campaign completed successfully!`,
        severity: 'success'
      });
    } catch (error) {
      console.error(`Error running ${campaignType} campaign:`, error);
      setSnackbar({
        open: true,
        message: `Failed to run ${campaignType} campaign`,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const analyzeUser = async () => {
    if (!selectedUser) {
      setSnackbar({
        open: true,
        message: 'Please select a user to analyze',
        severity: 'warning'
      });
      return;
    }

    try {
      setLoading(true);
      const response = await api.smartNotifications.getUserAnalysis(selectedUser);
      setUserAnalysis(response.data);
    } catch (error) {
      console.error('Error analyzing user:', error);
      setSnackbar({
        open: true,
        message: 'Failed to analyze user',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const sendSingleNotification = async () => {
    if (!selectedUser || !selectedTemplate) {
      setSnackbar({
        open: true,
        message: 'Please select both user and template',
        severity: 'warning'
      });
      return;
    }

    try {
      setLoading(true);
      await api.smartNotifications.sendToUser(selectedUser, selectedTemplate, customData);

      setSnackbar({
        open: true,
        message: 'Notification sent successfully!',
        severity: 'success'
      });

      // Reset form
      setSelectedUser('');
      setSelectedTemplate('');
      setCustomData({});
    } catch (error) {
      console.error('Error sending notification:', error);
      setSnackbar({
        open: true,
        message: 'Failed to send notification',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const runBulkAnalysis = async () => {
    try {
      setLoading(true);
      const response = await api.smartNotifications.sendBulkNotifications(null, 50);

      setCampaignResults(response);
      setSnackbar({
        open: true,
        message: 'Bulk analysis completed!',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error running bulk analysis:', error);
      setSnackbar({
        open: true,
        message: 'Failed to run bulk analysis',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const sendSegmentCampaign = async (segment) => {
    try {
      setLoading(true);
      
      // Use the segment criteria to send targeted notifications
      const response = await api.smartNotifications.sendTargetedNotifications(
        segment.criteria,
        'segment_campaign',
        { segmentName: segment.name }
      );

      setSnackbar({
        open: true,
        message: `Campaign sent to ${segment.name} segment successfully!`,
        severity: 'success'
      });

      // Log activity
      await logActivity({
        action: ActivityTypes.NOTIFICATION_CAMPAIGN,
        details: `Sent campaign to ${segment.name} segment`,
        metadata: {
          segmentId: segment.id,
          segmentName: segment.name,
          userCount: segment.userCount,
          results: response
        }
      });

    } catch (error) {
      console.error('Error sending segment campaign:', error);
      setSnackbar({
        open: true,
        message: `Failed to send campaign to ${segment.name} segment`,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const analyzeSegment = async (segment) => {
    try {
      setLoading(true);
      
      // Analyze the segment performance
      const response = await api.smartNotifications.getAnalytics({
        segment: segment.id,
        startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
        endDate: new Date().toISOString()
      });

      setSnackbar({
        open: true,
        message: `Analysis completed for ${segment.name} segment!`,
        severity: 'success'
      });

      // Log activity
      await logActivity({
        action: ActivityTypes.ANALYTICS,
        details: `Analyzed ${segment.name} segment`,
        metadata: {
          segmentId: segment.id,
          segmentName: segment.name,
          analysisResults: response
        }
      });

    } catch (error) {
      console.error('Error analyzing segment:', error);
      setSnackbar({
        open: true,
        message: `Failed to analyze ${segment.name} segment`,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const getCampaignIcon = (type) => {
    const icons = {
      'inactive-users': <PersonIcon />,
      'low-balance': <WarningIcon />,
      'high-value': <TrendingUpIcon />,
      'kyc-reminder': <CheckCircleIcon />
    };
    return icons[type] || <CampaignIcon />;
  };

  const getCampaignColor = (type) => {
    const colors = {
      'inactive-users': 'warning',
      'low-balance': 'error',
      'high-value': 'success',
      'kyc-reminder': 'info'
    };
    return colors[type] || 'primary';
  };

  const campaignCards = [
    {
      type: 'inactive-users',
      title: 'Inactive Users',
      description: 'Target users who haven\'t made transactions in the last 7 days',
      icon: <PersonIcon />,
      color: 'warning',
      gradient: 'linear-gradient(135deg, #ff9800 0%, #ff5722 100%)',
      stats: { icon: <TrendingDownIcon />, label: 'Inactive', value: '7+ days' }
    },
    {
      type: 'low-balance',
      title: 'Low Balance Users',
      description: 'Target users with balance less than ₦1,000',
      icon: <AccountBalanceIcon />,
      color: 'error',
      gradient: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
      stats: { icon: <WarningIcon />, label: 'Balance', value: '< ₦1,000' }
    },
    {
      type: 'high-value',
      title: 'High Value Customers',
      description: 'Target users who spent over ₦50,000 in the last 30 days',
      icon: <TrendingUpIcon />,
      color: 'success',
      gradient: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
      stats: { icon: <InsightsIcon />, label: 'Spent', value: '> ₦50,000' }
    },
    {
      type: 'kyc-reminder',
      title: 'KYC Reminder',
      description: 'Target users who haven\'t completed KYC verification',
      icon: <VerifiedUserIcon />,
      color: 'info',
      gradient: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)',
      stats: { icon: <CheckCircleIcon />, label: 'Status', value: 'Incomplete' }
    }
  ];

  return (
    <Box sx={{ 
      p: 3, 
      minHeight: '100vh',
      background: theme.palette.background.default
    }}>
      {/* Header Section */}
      <Fade in timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2, 
            mb: 2,
            p: 3,
            borderRadius: 2,
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: theme.shadows[1]
          }}>
            <Avatar sx={{ 
              bgcolor: theme.palette.primary.main,
              width: 56, 
              height: 56
            }}>
              <PsychologyIcon sx={{ fontSize: 28 }} />
            </Avatar>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h4" sx={{ 
                fontWeight: 600, 
                mb: 0.5,
                color: theme.palette.text.primary
              }}>
                Smart Notifications
              </Typography>
              <Typography variant="body1" sx={{ 
                color: theme.palette.text.secondary,
                lineHeight: 1.4
              }}>
                AI-powered notification system that analyzes user behavior and sends targeted marketing messages
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Chip 
                icon={<AutoAwesomeIcon />} 
                label="AI Powered" 
                size="small"
                color="primary"
                variant="outlined"
              />
              <Chip 
                icon={<TrendingUpIcon />} 
                label="Real-time" 
                size="small"
                color="secondary"
                variant="outlined"
              />
            </Box>
          </Box>
        </Box>
      </Fade>

            {/* Real-time Statistics Dashboard */}
      <Slide direction="up" in timeout={1000}>
        <Card sx={{ 
          mb: 3, 
          borderRadius: 2,
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[1]
        }}>
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
              <Avatar sx={{ 
                bgcolor: theme.palette.success.main,
                width: 48,
                height: 48
              }}>
                <ShowChartIcon sx={{ fontSize: 24 }} />
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" sx={{ 
                  fontWeight: 600,
                  color: theme.palette.text.primary
                }}>
                  Real-time Analytics
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  Live monitoring of notification performance and user engagement
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip 
                  icon={<SyncIcon />} 
                  label="Live" 
                  color="success" 
                  size="small"
                />
                <IconButton 
                  onClick={loadRealTimeStats}
                  disabled={realTimeStatsLoading}
                  size="small"
                >
                  {realTimeStatsLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <RefreshIcon sx={{ fontSize: 20 }} />
                  )}
                </IconButton>
              </Box>
            </Box>
            
                        <Grid container spacing={2}>
              <Grid item xs={6} md={2}>
                <Box sx={{ 
                  textAlign: 'center', 
                  p: 2,
                  borderRadius: 1,
                  background: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                  boxShadow: theme.shadows[1]
                }}>
                  <Avatar sx={{ 
                    bgcolor: theme.palette.primary.main,
                    width: 40,
                    height: 40,
                    mx: 'auto',
                    mb: 1
                  }}>
                    <PersonIcon />
                  </Avatar>
                  <Typography variant="h5" color="primary" sx={{ 
                    fontWeight: 600, 
                    mb: 0.5
                  }}>
                    {(realTimeStats.activeUsers || 0).toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Active Users (1h)
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={Math.min(100, ((realTimeStats.activeUsers || 0) / (realTimeStats.totalUsers || 1)) * 100)} 
                    sx={{ height: 4, borderRadius: 2 }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box sx={{ 
                  textAlign: 'center', 
                  p: 3,
                  borderRadius: 3,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.05)} 0%, ${alpha(theme.palette.background.default, 0.8)} 100%)`,
                  border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 8px 25px ${alpha(theme.palette.success.main, 0.15)}`,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.08)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`
                  }
                }}>
                  <Avatar sx={{ 
                    bgcolor: theme.palette.success.main,
                    width: 48,
                    height: 48,
                    mx: 'auto',
                    mb: 2,
                    boxShadow: `0 4px 20px ${alpha(theme.palette.success.main, 0.3)}`
                  }}>
                    <NotificationsIcon />
                  </Avatar>
                  <Typography variant="h4" color="success.main" sx={{ 
                    fontWeight: 800, 
                    mb: 1,
                    fontSize: '2rem'
                  }}>
                    {(realTimeStats.notificationsSent || 0).toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
                    Notifications (Today)
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={Math.min(100, (realTimeStats.notificationsSent || 0) / 1000 * 100)} 
                    sx={{ 
                      height: 6, 
                      borderRadius: 3,
                      bgcolor: alpha(theme.palette.success.main, 0.1),
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                        background: `linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.success.light} 100%)`
                      }
                    }}
                    color="success"
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box sx={{ 
                  textAlign: 'center', 
                  p: 3,
                  borderRadius: 3,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.05)} 0%, ${alpha(theme.palette.background.default, 0.8)} 100%)`,
                  border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 8px 25px ${alpha(theme.palette.info.main, 0.15)}`,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.08)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`
                  }
                }}>
                  <Avatar sx={{ 
                    bgcolor: theme.palette.info.main,
                    width: 48,
                    height: 48,
                    mx: 'auto',
                    mb: 2,
                    boxShadow: `0 4px 20px ${alpha(theme.palette.info.main, 0.3)}`
                  }}>
                    <CheckCircleIcon />
                  </Avatar>
                  <Typography variant="h4" color="info.main" sx={{ 
                    fontWeight: 800, 
                    mb: 1,
                    fontSize: '2rem'
                  }}>
                    {(realTimeStats.successRate || 0).toFixed(1)}%
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
                    Success Rate
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={realTimeStats.successRate || 0} 
                    sx={{ 
                      height: 6, 
                      borderRadius: 3,
                      bgcolor: alpha(theme.palette.info.main, 0.1),
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                        background: `linear-gradient(90deg, ${theme.palette.info.main} 0%, ${theme.palette.info.light} 100%)`
                      }
                    }}
                    color="info"
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box sx={{ 
                  textAlign: 'center', 
                  p: 3,
                  borderRadius: 3,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.warning.main, 0.05)} 0%, ${alpha(theme.palette.background.default, 0.8)} 100%)`,
                  border: `1px solid ${alpha(theme.palette.warning.main, 0.1)}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 8px 25px ${alpha(theme.palette.warning.main, 0.15)}`,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.warning.main, 0.08)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`
                  }
                }}>
                  <Avatar sx={{ 
                    bgcolor: theme.palette.warning.main,
                    width: 48,
                    height: 48,
                    mx: 'auto',
                    mb: 2,
                    boxShadow: `0 4px 20px ${alpha(theme.palette.warning.main, 0.3)}`
                  }}>
                    <TrendingUpIcon />
                  </Avatar>
                  <Typography variant="h4" color="warning.main" sx={{ 
                    fontWeight: 800, 
                    mb: 1,
                    fontSize: '2rem'
                  }}>
                    {(realTimeStats.engagementRate || 0).toFixed(1)}%
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
                    Engagement Rate
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={realTimeStats.engagementRate || 0} 
                    sx={{ 
                      height: 6, 
                      borderRadius: 3,
                      bgcolor: alpha(theme.palette.warning.main, 0.1),
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                        background: `linear-gradient(90deg, ${theme.palette.warning.main} 0%, ${theme.palette.warning.light} 100%)`
                      }
                    }}
                    color="warning"
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box sx={{ 
                  textAlign: 'center', 
                  p: 3,
                  borderRadius: 3,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.05)} 0%, ${alpha(theme.palette.background.default, 0.8)} 100%)`,
                  border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 8px 25px ${alpha(theme.palette.secondary.main, 0.15)}`,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.08)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`
                  }
                }}>
                  <Avatar sx={{ 
                    bgcolor: theme.palette.secondary.main,
                    width: 48,
                    height: 48,
                    mx: 'auto',
                    mb: 2,
                    boxShadow: `0 4px 20px ${alpha(theme.palette.secondary.main, 0.3)}`
                  }}>
                    <GroupIcon />
                  </Avatar>
                  <Typography variant="h4" color="secondary.main" sx={{ 
                    fontWeight: 800, 
                    mb: 1,
                    fontSize: '2rem'
                  }}>
                    {(realTimeStats.totalUsers || 0).toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
                    Total Users
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={100} 
                    sx={{ 
                      height: 6, 
                      borderRadius: 3,
                      bgcolor: alpha(theme.palette.secondary.main, 0.1),
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                        background: `linear-gradient(90deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.light} 100%)`
                      }
                    }}
                    color="secondary"
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box sx={{ 
                  textAlign: 'center', 
                  p: 3,
                  borderRadius: 3,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.error.main, 0.05)} 0%, ${alpha(theme.palette.background.default, 0.8)} 100%)`,
                  border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 8px 25px ${alpha(theme.palette.error.main, 0.15)}`,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.error.main, 0.08)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`
                  }
                }}>
                  <Avatar sx={{ 
                    bgcolor: theme.palette.error.main,
                    width: 48,
                    height: 48,
                    mx: 'auto',
                    mb: 2,
                    boxShadow: `0 4px 20px ${alpha(theme.palette.error.main, 0.3)}`
                  }}>
                    <ActivityIcon />
                  </Avatar>
                  <Typography variant="h4" color="error.main" sx={{ 
                    fontWeight: 800, 
                    mb: 1,
                    fontSize: '2rem'
                  }}>
                    {(realTimeStats.recentActivity || 0).toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
                    Recent Activity (1h)
                  </Typography>
                  <LinearProgress 
                    variant="determinate" 
                    value={Math.min(100, (realTimeStats.recentActivity || 0) / 100 * 100)} 
                    sx={{ 
                      height: 6, 
                      borderRadius: 3,
                      bgcolor: alpha(theme.palette.error.main, 0.1),
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 3,
                        background: `linear-gradient(90deg, ${theme.palette.error.main} 0%, ${theme.palette.error.light} 100%)`
                      }
                    }}
                    color="error"
                  />
                </Box>
              </Grid>
            </Grid>
            
            {/* Last Updated Indicator */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2, pt: 2, borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SyncIcon sx={{ fontSize: 14 }} />
                Last updated: {realTimeStats.lastUpdated ? new Date(realTimeStats.lastUpdated).toLocaleTimeString() : 'Never'}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Slide>

      {/* Search and Filter Bar */}
      <Slide direction="down" in timeout={1200}>
        <Paper sx={{ 
          mb: 3, 
          p: 2,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`,
          backdropFilter: 'blur(10px)',
          boxShadow: theme.shadows[4]
        }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Search campaigns, users, or templates..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                  endAdornment: searchQuery && (
                    <IconButton size="small" onClick={() => setSearchQuery('')}>
                      <VisibilityOffIcon />
                    </IconButton>
                  )
                }}
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Filter Type</InputLabel>
                <Select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  label="Filter Type"
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                  <MenuItem value="scheduled">Scheduled</MenuItem>
                  <MenuItem value="draft">Draft</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  label="Sort By"
                >
                  <MenuItem value="date">Date</MenuItem>
                  <MenuItem value="name">Name</MenuItem>
                  <MenuItem value="performance">Performance</MenuItem>
                  <MenuItem value="engagement">Engagement</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={(e, newMode) => newMode && setViewMode(newMode)}
                size="small"
                fullWidth
              >
                <ToggleButton value="grid" aria-label="grid">
                  <ViewComfyIcon />
                </ToggleButton>
                <ToggleButton value="list" aria-label="list">
                  <ViewCompactIcon />
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Paper>
      </Slide>

      {/* Tabs Section */}
      <Zoom in timeout={1000}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`,
          backdropFilter: 'blur(10px)',
          boxShadow: theme.shadows[4]
        }}>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{
              '& .MuiTab-root': {
                minHeight: 64,
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: 0,
                '&.Mui-selected': {
                  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.primary.main, 0.05)} 100%)`,
                  color: theme.palette.primary.main,
                }
              },
              '& .MuiTabs-indicator': {
                height: 4,
                borderRadius: 2,
                background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`
              }
            }}
          >
            <Tab 
              label="Campaigns" 
              icon={<CampaignIcon />} 
              iconPosition="start"
            />
            <Tab 
              label="User Analysis" 
              icon={<AnalyticsIcon />} 
              iconPosition="start"
            />
            <Tab 
              label="Templates" 
              icon={<SettingsIcon />} 
              iconPosition="start"
            />
            <Tab 
              label="Segments" 
              icon={<PieChartIcon />} 
              iconPosition="start"
            />
            <Tab 
              label="A/B Testing" 
              icon={<ScienceIcon />} 
              iconPosition="start"
            />
            <Tab 
              label="Scheduled" 
              icon={<ScheduleIcon />} 
              iconPosition="start"
            />
          </Tabs>
        </Paper>
      </Zoom>

      {/* Loading Overlay */}
      {loading && (
        <Box sx={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          bgcolor: 'rgba(0,0,0,0.5)', 
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(5px)'
        }}>
          <Card sx={{ p: 4, borderRadius: 3, textAlign: 'center' }}>
            <CircularProgress size={60} sx={{ mb: 2 }} />
            <Typography variant="h6">Processing...</Typography>
          </Card>
        </Box>
      )}

      {/* Campaigns Tab */}
      {activeTab === 0 && (
        <Grow in timeout={600}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={handleTriggerMeterLow}
                    disabled={triggeringMeterLow}
                    startIcon={triggeringMeterLow ? <CircularProgress size={20} /> : <WarningIcon />}
                    sx={{ minWidth: 220 }}
                  >
                    {triggeringMeterLow ? 'Sending Meter Low Alerts...' : 'Send Meter Low Notifications'}
                  </Button>
                </Box>
                {campaignCards.map((campaign, index) => (
                  <Grid item xs={12} md={6} key={campaign.type}>
                    <Slide direction="up" in timeout={800 + index * 200}>
                      <Card sx={{ 
                        height: '100%',
                        borderRadius: 2,
                        overflow: 'hidden',
                        background: theme.palette.background.paper,
                        border: `1px solid ${theme.palette.divider}`,
                        boxShadow: theme.shadows[1],
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          boxShadow: theme.shadows[4]
                        }
                      }}>
                        <Box 
                          sx={{ 
                            p: 3, 
                            background: theme.palette.primary.main,
                            color: 'white'
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <Avatar sx={{ 
                              bgcolor: 'rgba(255,255,255,0.2)', 
                              width: 48, 
                              height: 48
                            }}>
                              {campaign.icon}
                            </Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="h6" sx={{ 
                                fontWeight: 600, 
                                mb: 0.5
                              }}>
                                {campaign.title}
                              </Typography>
                              <Typography variant="body2" sx={{ 
                                opacity: 0.9,
                                lineHeight: 1.4
                              }}>
                                {campaign.description}
                              </Typography>
                            </Box>
                          </Box>
                          <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1,
                            p: 1.5,
                            borderRadius: 1,
                            bgcolor: 'rgba(255,255,255,0.1)'
                          }}>
                            {campaign.stats.icon}
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {campaign.stats.label}: {campaign.stats.value}
                            </Typography>
                          </Box>
                        </Box>
                        
                        <CardContent sx={{ p: 3 }}>
                          <TextField
                            type="number"
                            label="User Limit"
                            value={campaignSettings[campaign.type]?.limit || 100}
                            onChange={(e) => setCampaignSettings(prev => ({
                              ...prev,
                              [campaign.type]: { ...prev[campaign.type], limit: parseInt(e.target.value) }
                            }))}
                            size="small"
                            sx={{ mb: 3, width: '100%' }}
                            InputProps={{
                              startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                            }}
                          />
                          <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                            <Button
                              variant="contained"
                              color={campaign.color}
                              onClick={() => runCampaign(campaign.type)}
                              disabled={loading}
                              startIcon={loading ? <CircularProgress size={20} /> : <RocketLaunchIcon />}
                              sx={{
                                flex: 1,
                                height: 40,
                                textTransform: 'none',
                                fontWeight: 600
                              }}
                            >
                              Launch
                            </Button>
                            <IconButton size="small">
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton size="small">
                              <EditIcon />
                            </IconButton>
                          </Stack>
                          
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Chip 
                              label="AI Optimized" 
                              size="small" 
                              color="success" 
                              icon={<AutoAwesomeIcon />}
                            />
                            <Chip 
                              label="Real-time" 
                              size="small" 
                              color="info" 
                              icon={<SyncIcon />}
                            />
                          </Box>
                        </CardContent>
                      </Card>
                    </Slide>
                  </Grid>
                ))}
              </Grid>

              {/* Campaign Results */}
              {campaignResults && (
                <Slide direction="up" in timeout={800}>
                  <Card sx={{ 
                    mt: 4, 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.1)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
                    border: `2px solid ${alpha(theme.palette.success.main, 0.2)}`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar sx={{ bgcolor: theme.palette.success.main }}>
                          <CheckCircleIcon />
                        </Avatar>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                          Campaign Results
                        </Typography>
                      </Box>
                      <Grid container spacing={3}>
                        <Grid item xs={6} md={3}>
                          <Box sx={{ textAlign: 'center', p: 2 }}>
                            <Typography variant="h3" color="primary" sx={{ fontWeight: 700 }}>
                              {campaignResults.data?.total || 0}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Total Users
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Box sx={{ textAlign: 'center', p: 2 }}>
                            <Typography variant="h3" color="success.main" sx={{ fontWeight: 700 }}>
                              {campaignResults.data?.successful || 0}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Notifications Sent
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Box sx={{ textAlign: 'center', p: 2 }}>
                            <Typography variant="h3" color="error.main" sx={{ fontWeight: 700 }}>
                              {campaignResults.data?.failed || 0}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Failed
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Box sx={{ textAlign: 'center', p: 2 }}>
                            <Typography variant="h3" color="warning.main" sx={{ fontWeight: 700 }}>
                              {campaignResults.data?.skipped || 0}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Skipped
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Slide>
              )}
            </Grid>
          </Box>
        </Grow>
      )}

      {/* User Analysis Tab */}
      {activeTab === 1 && (
        <Grow in timeout={600}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Slide direction="left" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar sx={{ bgcolor: theme.palette.info.main }}>
                          <AnalyticsIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          Individual User Analysis
                        </Typography>
                      </Box>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel>Select User</InputLabel>
                        <Select
                          value={selectedUser}
                          onChange={(e) => setSelectedUser(e.target.value)}
                          label="Select User"
                          disabled={usersLoading}
                          startAdornment={
                            usersLoading ? (
                              <CircularProgress size={20} sx={{ mr: 1 }} />
                            ) : (
                              <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                            )
                          }
                        >
                          <MenuItem value="">
                            <em>Select a user to analyze</em>
                          </MenuItem>
                          <MenuItem sx={{ p: 0 }}>
                            <TextField
                              size="small"
                              placeholder="Search users..."
                              value={userSearchQuery}
                              onChange={(e) => setUserSearchQuery(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                              sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: 0 } }}
                              InputProps={{
                                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
                              }}
                            />
                          </MenuItem>
                          <Divider />
                          {filteredUsers.length > 0 ? (
                            filteredUsers.map((user) => (
                              <MenuItem key={user._id} value={user._id}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem' }}>
                                    {user.fullname ? user.fullname.charAt(0).toUpperCase() : 'U'}
                                  </Avatar>
                                  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {user.fullname || user.phone || 'Unknown User'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      {user.phone || user.email || user._id}
                                    </Typography>
                                  </Box>
                                </Box>
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>
                              <Typography variant="body2" color="text.secondary">
                                No users found
                              </Typography>
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>
                      <Button
                        variant="contained"
                        onClick={analyzeUser}
                        disabled={loading || !selectedUser}
                        startIcon={loading ? <CircularProgress size={20} /> : <InsightsIcon />}
                        fullWidth
                        sx={{
                          height: 48,
                          borderRadius: 2,
                          textTransform: 'none',
                          fontSize: '1rem',
                          fontWeight: 600,
                          background: `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.info.dark} 100%)`
                        }}
                      >
                        Analyze User Behavior
                      </Button>
                    </CardContent>
                  </Card>
                </Slide>

                {userAnalysis && (
                  <Slide direction="left" in timeout={1000}>
                    <Card sx={{ 
                      mt: 3, 
                      borderRadius: 3,
                      background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                    }}>
                      <CardContent sx={{ p: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                          <Avatar sx={{ bgcolor: theme.palette.success.main }}>
                            <TimelineIcon />
                          </Avatar>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Analysis Results
                          </Typography>
                        </Box>
                        <List>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              {userAnalysis.isInactive ? 
                                <WarningIcon color="warning" /> : 
                                <CheckCircleIcon color="success" />
                              }
                            </ListItemIcon>
                            <ListItemText 
                              primary="Activity Status" 
                              secondary={userAnalysis.isInactive ? "Inactive (7+ days)" : "Active"} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              {userAnalysis.hasLowBalance ? 
                                <WarningIcon color="error" /> : 
                                <CheckCircleIcon color="success" />
                              }
                            </ListItemIcon>
                            <ListItemText 
                              primary="Balance Status" 
                              secondary={userAnalysis.hasLowBalance ? "Low Balance" : "Healthy Balance"} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              {userAnalysis.isHighValueCustomer ? 
                                <TrendingUpIcon color="success" /> : 
                                <PersonIcon />
                              }
                            </ListItemIcon>
                            <ListItemText 
                              primary="Customer Value" 
                              secondary={userAnalysis.isHighValueCustomer ? "High Value" : "Regular Customer"} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              {userAnalysis.hasCompletedKYC ? 
                                <CheckCircleIcon color="success" /> : 
                                <WarningIcon color="warning" />
                              }
                            </ListItemIcon>
                            <ListItemText 
                              primary="KYC Status" 
                              secondary={userAnalysis.hasCompletedKYC ? "Completed" : "Incomplete"} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              <AnalyticsIcon />
                            </ListItemIcon>
                            <ListItemText 
                              primary="Transaction Frequency" 
                              secondary={`${userAnalysis.transactionFrequency} transactions (30 days)`} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              <ScheduleIcon />
                            </ListItemIcon>
                            <ListItemText 
                              primary="Preferred Time" 
                              secondary={`${userAnalysis.preferredTransactionTime}:00`} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              <TrendingUpIcon />
                            </ListItemIcon>
                            <ListItemText 
                              primary="Customer Tier" 
                              secondary={userAnalysis.customerTier || 'Regular'} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              <AccountBalanceIcon />
                            </ListItemIcon>
                            <ListItemText 
                              primary="Total Spent (30 days)" 
                              secondary={`₦${(userAnalysis.totalSpent || 0).toLocaleString()}`} 
                            />
                          </ListItem>
                          <ListItem sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                            <ListItemIcon>
                              <CheckCircleIcon />
                            </ListItemIcon>
                            <ListItemText 
                              primary="KYC Completion" 
                              secondary={`${userAnalysis.kycCompletionPercentage || 0}% complete`} 
                            />
                          </ListItem>
                        </List>
                      </CardContent>
                    </Card>
                  </Slide>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Slide direction="right" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                          <SendIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          Send Single Notification
                        </Typography>
                      </Box>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel>Select User</InputLabel>
                        <Select
                          value={selectedUser}
                          onChange={(e) => setSelectedUser(e.target.value)}
                          label="Select User"
                          disabled={usersLoading}
                          startAdornment={
                            usersLoading ? (
                              <CircularProgress size={20} sx={{ mr: 1 }} />
                            ) : (
                              <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                            )
                          }
                        >
                          <MenuItem value="">
                            <em>Select a user to send notification</em>
                          </MenuItem>
                          <MenuItem sx={{ p: 0 }}>
                            <TextField
                              size="small"
                              placeholder="Search users..."
                              value={userSearchQuery}
                              onChange={(e) => setUserSearchQuery(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                              sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: 0 } }}
                              InputProps={{
                                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
                              }}
                            />
                          </MenuItem>
                          <Divider />
                          {filteredUsers.length > 0 ? (
                            filteredUsers.map((user) => (
                              <MenuItem key={user._id} value={user._id}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem' }}>
                                    {user.fullname ? user.fullname.charAt(0).toUpperCase() : 'U'}
                                  </Avatar>
                                  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {user.fullname || user.phone || 'Unknown User'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      {user.phone || user.email || user._id}
                                    </Typography>
                                  </Box>
                                </Box>
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>
                              <Typography variant="body2" color="text.secondary">
                                No users found
                              </Typography>
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel>Template</InputLabel>
                        <Select
                          value={selectedTemplate}
                          onChange={(e) => setSelectedTemplate(e.target.value)}
                          label="Template"
                        >
                          {Object.keys(templates).map((key) => (
                            <MenuItem key={key} value={key}>
                              {templates[key]?.title || key}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Button
                        variant="contained"
                        onClick={sendSingleNotification}
                        disabled={loading || !selectedUser || !selectedTemplate}
                        startIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
                        fullWidth
                        sx={{
                          height: 48,
                          borderRadius: 2,
                          textTransform: 'none',
                          fontSize: '1rem',
                          fontWeight: 600,
                          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
                        }}
                      >
                        Send Notification
                      </Button>
                    </CardContent>
                  </Card>
                </Slide>

                <Slide direction="right" in timeout={1000}>
                  <Card sx={{ 
                    mt: 3, 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.warning.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar sx={{ bgcolor: theme.palette.warning.main }}>
                          <RefreshIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          Bulk Analysis
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Analyze and send smart notifications to multiple users automatically
                      </Typography>
                      <Button
                        variant="outlined"
                        onClick={runBulkAnalysis}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} /> : <RefreshIcon />}
                        fullWidth
                        sx={{
                          height: 48,
                          borderRadius: 2,
                          textTransform: 'none',
                          fontSize: '1rem',
                          fontWeight: 600,
                          borderColor: theme.palette.warning.main,
                          color: theme.palette.warning.main,
                          '&:hover': {
                            borderColor: theme.palette.warning.dark,
                            bgcolor: alpha(theme.palette.warning.main, 0.1)
                          }
                        }}
                      >
                        Run Bulk Analysis
                      </Button>
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>
            </Grid>
          </Box>
        </Grow>
      )}

      {/* Templates Tab */}
      {activeTab === 2 && (
        <Grow in timeout={600}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Slide direction="down" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                            <SettingsIcon />
                          </Avatar>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Notification Templates
                          </Typography>
                        </Box>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={() => setTemplateManagement(prev => ({ ...prev, showCreateModal: true }))}
                        >
                          Create Template
                        </Button>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Manage notification templates for different campaign types
                      </Typography>
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>

              {Object.entries(templates).map(([key, template], index) => (
                <Grid item xs={12} md={6} key={key}>
                  <Slide direction="up" in timeout={800 + index * 100}>
                    <Card sx={{ 
                      borderRadius: 3,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: theme.shadows[8]
                      }
                    }}>
                      <CardContent sx={{ p: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                              <NotificationsIcon />
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                              {template.title}
                            </Typography>
                          </Box>
                          <IconButton>
                            <MoreVertIcon />
                          </IconButton>
                        </Box>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                          {template.content}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                          <Chip 
                            label={key} 
                            size="small" 
                            color="primary" 
                            sx={{ fontWeight: 600 }}
                          />
                          <Chip 
                            label={template.category || 'marketing'} 
                            size="small" 
                            variant="outlined"
                          />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => setTemplateManagement(prev => ({
                              ...prev,
                              editingTemplate: template,
                              newTemplate: { ...template },
                              showCreateModal: true
                            }))}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<SendIcon />}
                          >
                            Use Template
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grow>
      )}

      {/* Segments Tab */}
      {activeTab === 3 && (
        <Grow in timeout={600}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Slide direction="down" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                            <PieChartIcon />
                          </Avatar>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            User Segments
                          </Typography>
                        </Box>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={() => setSegments(prev => [...prev, {
                            id: Date.now(),
                            name: 'New Segment',
                            criteria: {},
                            userCount: 0,
                            description: 'New user segment'
                          }])}
                        >
                          Create Segment
                        </Button>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Create and manage user segments for targeted marketing campaigns
                      </Typography>
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>

              {segmentsLoading ? (
                // Loading skeleton
                Array.from({ length: 4 }).map((_, index) => (
                  <Grid item xs={12} md={6} key={`skeleton-${index}`}>
                    <Card sx={{ borderRadius: 3 }}>
                      <CardContent sx={{ p: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                          <Skeleton variant="circular" width={40} height={40} />
                          <Box sx={{ flex: 1 }}>
                            <Skeleton variant="text" width="60%" height={24} />
                            <Skeleton variant="text" width="40%" height={16} />
                          </Box>
                        </Box>
                        <Skeleton variant="text" width="100%" height={16} sx={{ mb: 2 }} />
                        <Skeleton variant="text" width="80%" height={16} sx={{ mb: 2 }} />
                        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                          <Skeleton variant="rounded" width={80} height={24} />
                          <Skeleton variant="rounded" width={80} height={24} />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Skeleton variant="rounded" width={100} height={32} />
                          <Skeleton variant="rounded" width={80} height={32} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              ) : segments.length > 0 ? (
                segments.map((segment, index) => (
                  <Grid item xs={12} md={6} key={segment.id}>
                    <Slide direction="up" in timeout={800 + index * 200}>
                      <Card sx={{ 
                        borderRadius: 3,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: theme.shadows[8]
                        }
                      }}>
                        <CardContent sx={{ p: 4 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <Avatar sx={{ 
                                bgcolor: index === 0 ? theme.palette.success.main : 
                                         index === 1 ? theme.palette.warning.main :
                                         index === 2 ? theme.palette.error.main : theme.palette.info.main,
                                width: 40, height: 40
                              }}>
                                <PersonIcon />
                              </Avatar>
                              <Box>
                                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                  {segment.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {segment.userCount.toLocaleString()} users
                                </Typography>
                              </Box>
                            </Box>
                            <IconButton>
                              <MoreVertIcon />
                            </IconButton>
                          </Box>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {segment.description}
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {Object.entries(segment.criteria).map(([key, value]) => (
                              <Chip 
                                key={key}
                                label={`${key}: ${value}`} 
                                size="small" 
                                variant="outlined"
                              />
                            ))}
                          </Box>
                          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<SendIcon />}
                              onClick={() => sendSegmentCampaign(segment)}
                              disabled={loading}
                            >
                              Send Campaign
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<AnalyticsIcon />}
                              onClick={() => analyzeSegment(segment)}
                              disabled={loading}
                            >
                              Analyze
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Slide>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Card sx={{ borderRadius: 3, textAlign: 'center', py: 6 }}>
                    <Typography variant="h6" gutterBottom>
                      No Segments Found
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                      Create a new segment to get started.
                    </Typography>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grow>
      )}

      {/* A/B Testing Tab */}
      {activeTab === 4 && (
        <Grow in timeout={600}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Slide direction="down" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ bgcolor: theme.palette.secondary.main }}>
                            <ScienceIcon />
                          </Avatar>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            A/B Testing
                          </Typography>
                        </Box>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={() => setAbTestData(prev => ({ ...prev, showCreateModal: true }))}
                        >
                          Create Test
                        </Button>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Test different notification variants to optimize engagement and conversion rates
                      </Typography>
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>

              {abTestData.activeTests.length > 0 ? (
                abTestData.activeTests.map((test, index) => (
                  <Grid item xs={12} key={test.id}>
                    <Slide direction="up" in timeout={800 + index * 200}>
                      <Card sx={{ 
                        borderRadius: 3,
                        background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                      }}>
                        <CardContent sx={{ p: 4 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                              {test.name}
                            </Typography>
                            <Chip 
                              label={test.status || 'Active'} 
                              color={test.status === 'Completed' ? 'success' : 'warning'}
                            />
                          </Box>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <Typography variant="subtitle2" gutterBottom>
                                Variant A
                              </Typography>
                              <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                  {test.variantA.subject}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {test.variantA.content}
                                </Typography>
                              </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="subtitle2" gutterBottom>
                                Variant B
                              </Typography>
                              <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                  {test.variantB.subject}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {test.variantB.content}
                                </Typography>
                              </Card>
                            </Grid>
                          </Grid>
                          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button variant="outlined" size="small">
                              View Results
                            </Button>
                            <Button variant="outlined" size="small">
                              Stop Test
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Slide>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Slide direction="up" in timeout={800}>
                    <Card sx={{ 
                      borderRadius: 3,
                      textAlign: 'center',
                      py: 6
                    }}>
                      <ScienceIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                      <Typography variant="h6" gutterBottom>
                        No Active A/B Tests
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Create your first A/B test to optimize notification performance
                      </Typography>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => setAbTestData(prev => ({ ...prev, showCreateModal: true }))}
                      >
                        Create Your First Test
                      </Button>
                    </Card>
                  </Slide>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grow>
      )}

      {/* Scheduled Tab */}
      {activeTab === 5 && (
        <Grow in timeout={600}>
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Slide direction="left" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                          <ScheduleSendIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          Morning Promotions
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Send promotional notifications to users during their preferred morning hours (6-10 AM)
                      </Typography>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={campaignSettings.morningPromo.enabled}
                            onChange={(e) => setCampaignSettings(prev => ({
                              ...prev,
                              morningPromo: { ...prev.morningPromo, enabled: e.target.checked }
                            }))}
                          />
                        }
                        label="Enable Morning Promotions"
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        type="number"
                        label="User Limit"
                        value={campaignSettings.morningPromo.limit}
                        onChange={(e) => setCampaignSettings(prev => ({
                          ...prev,
                          morningPromo: { ...prev.morningPromo, limit: parseInt(e.target.value) }
                        }))}
                        size="small"
                        sx={{ width: '100%' }}
                        InputProps={{
                          startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>

              <Grid item xs={12} md={6}>
                <Slide direction="right" in timeout={800}>
                  <Card sx={{ 
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(theme.palette.secondary.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Avatar sx={{ bgcolor: theme.palette.secondary.main }}>
                          <ScheduleSendIcon />
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          Evening Promotions
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Send promotional notifications to users during their preferred evening hours (6-10 PM)
                      </Typography>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={campaignSettings.eveningPromo.enabled}
                            onChange={(e) => setCampaignSettings(prev => ({
                              ...prev,
                              eveningPromo: { ...prev.eveningPromo, enabled: e.target.checked }
                            }))}
                          />
                        }
                        label="Enable Evening Promotions"
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        type="number"
                        label="User Limit"
                        value={campaignSettings.eveningPromo.limit}
                        onChange={(e) => setCampaignSettings(prev => ({
                          ...prev,
                          eveningPromo: { ...prev.eveningPromo, limit: parseInt(e.target.value) }
                        }))}
                        size="small"
                        sx={{ width: '100%' }}
                        InputProps={{
                          startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </CardContent>
                  </Card>
                </Slide>
              </Grid>
            </Grid>

            <Slide direction="up" in timeout={1000}>
              <Card sx={{ 
                mt: 4, 
                borderRadius: 3,
                background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
              }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                    <Avatar sx={{ bgcolor: theme.palette.info.main }}>
                      <CampaignOutlinedIcon />
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      Scheduled Campaigns Status
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    These campaigns run automatically based on user behavior patterns and preferred transaction times.
                    The system analyzes user activity and sends notifications at optimal times for maximum engagement.
                  </Typography>
                </CardContent>
              </Card>
            </Slide>
          </Box>
        </Grow>
      )}

      {/* Floating Action Button with Speed Dial */}
      <SpeedDial
        ariaLabel="Quick Actions"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        open={showSpeedDial}
        onOpen={() => setShowSpeedDial(true)}
        onClose={() => setShowSpeedDial(false)}
      >
        <SpeedDialAction
          icon={<AnalyticsIcon />}
          tooltipTitle="Analytics"
          onClick={() => {
            setShowAnalyticsModal(true);
            loadAnalyticsData(); // Load fresh data when opening
          }}
        />
        <SpeedDialAction
          icon={<SettingsIcon />}
          tooltipTitle="Advanced Settings"
          onClick={() => setShowAdvancedModal(true)}
        />
        <SpeedDialAction
          icon={<AddIcon />}
          tooltipTitle="New Campaign"
          onClick={() => setActiveTab(0)}
        />
        <SpeedDialAction
          icon={<DownloadIcon />}
          tooltipTitle="Export Data"
          onClick={() => {
            setSnackbar({
              open: true,
              message: 'Exporting data...',
              severity: 'info'
            });
          }}
        />
      </SpeedDial>

      {/* Advanced Settings Modal */}
      <Dialog
        open={showAdvancedModal}
        onClose={() => setShowAdvancedModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <SettingsIcon />
            Advanced Campaign Settings
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={advancedSettings.aiOptimization}
                    onChange={(e) => setAdvancedSettings(prev => ({
                      ...prev,
                      aiOptimization: e.target.checked
                    }))}
                  />
                }
                label="AI Optimization"
              />
              <Typography variant="body2" color="text.secondary" sx={{ ml: 4, mb: 2 }}>
                Use AI to optimize notification timing and content
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={advancedSettings.timingOptimization}
                    onChange={(e) => setAdvancedSettings(prev => ({
                      ...prev,
                      timingOptimization: e.target.checked
                    }))}
                  />
                }
                label="Timing Optimization"
              />
              <Typography variant="body2" color="text.secondary" sx={{ ml: 4, mb: 2 }}>
                Send notifications at optimal times for each user
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Personalization Level
              </Typography>
              <Slider
                value={advancedSettings.personalizationLevel}
                onChange={(e, value) => setAdvancedSettings(prev => ({
                  ...prev,
                  personalizationLevel: value
                }))}
                min={1}
                max={5}
                marks
                valueLabelDisplay="auto"
                sx={{ ml: 2 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Performance Threshold
              </Typography>
              <Slider
                value={advancedSettings.performanceThreshold}
                onChange={(e, value) => setAdvancedSettings(prev => ({
                  ...prev,
                  performanceThreshold: value
                }))}
                min={0}
                max={1}
                step={0.1}
                valueLabelDisplay="auto"
                sx={{ ml: 2 }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAdvancedModal(false)}>Cancel</Button>
          <Button 
            variant="contained" 
            onClick={() => {
              setShowAdvancedModal(false);
              setSnackbar({
                open: true,
                message: 'Advanced settings saved successfully!',
                severity: 'success'
              });
            }}
          >
            Save Settings
          </Button>
        </DialogActions>
      </Dialog>

      {/* A/B Testing Creation Modal */}
      <Dialog
        open={abTestData.showCreateModal}
        onClose={() => setAbTestData(prev => ({ ...prev, showCreateModal: false }))}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ScienceIcon />
            Create A/B Test
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Test Name"
                value={abTestData.newTest.name}
                onChange={(e) => setAbTestData(prev => ({
                  ...prev,
                  newTest: { ...prev.newTest, name: e.target.value }
                }))}
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Variant A
              </Typography>
              <TextField
                fullWidth
                label="Subject Line"
                value={abTestData.newTest.variantA.subject}
                onChange={(e) => setAbTestData(prev => ({
                  ...prev,
                  newTest: { 
                    ...prev.newTest, 
                    variantA: { ...prev.newTest.variantA, subject: e.target.value }
                  }
                }))}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Content"
                value={abTestData.newTest.variantA.content}
                onChange={(e) => setAbTestData(prev => ({
                  ...prev,
                  newTest: { 
                    ...prev.newTest, 
                    variantA: { ...prev.newTest.variantA, content: e.target.value }
                  }
                }))}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Variant B
              </Typography>
              <TextField
                fullWidth
                label="Subject Line"
                value={abTestData.newTest.variantB.subject}
                onChange={(e) => setAbTestData(prev => ({
                  ...prev,
                  newTest: { 
                    ...prev.newTest, 
                    variantB: { ...prev.newTest.variantB, subject: e.target.value }
                  }
                }))}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Content"
                value={abTestData.newTest.variantB.content}
                onChange={(e) => setAbTestData(prev => ({
                  ...prev,
                  newTest: { 
                    ...prev.newTest, 
                    variantB: { ...prev.newTest.variantB, content: e.target.value }
                  }
                }))}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Target Segment</InputLabel>
                <Select
                  value={abTestData.newTest.targetSegment}
                  onChange={(e) => setAbTestData(prev => ({
                    ...prev,
                    newTest: { ...prev.newTest, targetSegment: e.target.value }
                  }))}
                  label="Target Segment"
                >
                  <MenuItem value="all">All Users</MenuItem>
                  <MenuItem value="high-value">High Value Customers</MenuItem>
                  <MenuItem value="inactive">Inactive Users</MenuItem>
                  <MenuItem value="new">New Users</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="number"
                label="Test Duration (days)"
                value={abTestData.newTest.testDuration}
                onChange={(e) => setAbTestData(prev => ({
                  ...prev,
                  newTest: { ...prev.newTest, testDuration: parseInt(e.target.value) }
                }))}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAbTestData(prev => ({ ...prev, showCreateModal: false }))}>
            Cancel
          </Button>
          <Button 
            variant="contained"
            onClick={() => {
              // Add the new test to active tests
              setAbTestData(prev => ({
                ...prev,
                activeTests: [...prev.activeTests, {
                  id: Date.now(),
                  ...prev.newTest,
                  status: 'Active',
                  createdAt: new Date()
                }],
                showCreateModal: false,
                newTest: {
                  name: '',
                  variantA: { subject: '', content: '' },
                  variantB: { subject: '', content: '' },
                  targetSegment: 'all',
                  testDuration: 7,
                  successMetric: 'click_rate'
                }
              }));
              setSnackbar({
                open: true,
                message: 'A/B test created successfully!',
                severity: 'success'
              });
            }}
          >
            Create Test
          </Button>
        </DialogActions>
      </Dialog>

      {/* Template Management Modal */}
      <Dialog
        open={templateManagement.showCreateModal}
        onClose={() => setTemplateManagement(prev => ({ ...prev, showCreateModal: false }))}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <SettingsIcon />
            {templateManagement.editingTemplate ? 'Edit Template' : 'Create Template'}
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Template Key"
                value={templateManagement.newTemplate.key}
                onChange={(e) => setTemplateManagement(prev => ({
                  ...prev,
                  newTemplate: { ...prev.newTemplate, key: e.target.value }
                }))}
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={templateManagement.newTemplate.category}
                  onChange={(e) => setTemplateManagement(prev => ({
                    ...prev,
                    newTemplate: { ...prev.newTemplate, category: e.target.value }
                  }))}
                  label="Category"
                >
                  <MenuItem value="marketing">Marketing</MenuItem>
                  <MenuItem value="reminder">Reminder</MenuItem>
                  <MenuItem value="alert">Alert</MenuItem>
                  <MenuItem value="promo">Promotion</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Template Title"
                value={templateManagement.newTemplate.title}
                onChange={(e) => setTemplateManagement(prev => ({
                  ...prev,
                  newTemplate: { ...prev.newTemplate, title: e.target.value }
                }))}
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Template Content"
                value={templateManagement.newTemplate.content}
                onChange={(e) => setTemplateManagement(prev => ({
                  ...prev,
                  newTemplate: { ...prev.newTemplate, content: e.target.value }
                }))}
                helperText="Use {{variable}} syntax for dynamic content"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTemplateManagement(prev => ({ ...prev, showCreateModal: false }))}>
            Cancel
          </Button>
          <Button 
            variant="contained"
            onClick={() => {
              setTemplateManagement(prev => ({ ...prev, showCreateModal: false }));
              setSnackbar({
                open: true,
                message: templateManagement.editingTemplate ? 'Template updated successfully!' : 'Template created successfully!',
                severity: 'success'
              });
            }}
          >
            {templateManagement.editingTemplate ? 'Update Template' : 'Create Template'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Enhanced Analytics Modal */}
      <Dialog
        open={showAnalyticsModal}
        onClose={() => setShowAnalyticsModal(false)}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.info.dark} 100%)`,
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <AnalyticsIcon />
              Advanced Analytics Dashboard
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip 
                icon={<SyncIcon />} 
                label="Live Data" 
                size="small"
                sx={{ 
                  bgcolor: 'rgba(255,255,255,0.2)', 
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.3)'
                  }
                }}
              />
              <IconButton 
                onClick={loadAnalyticsData}
                disabled={analyticsLoading}
                sx={{ color: 'white' }}
                size="small"
              >
                {analyticsLoading ? (
                  <CircularProgress size={20} sx={{ color: 'white' }} />
                ) : (
                  <RefreshIcon />
                )}
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
          {analyticsLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
              <CircularProgress size={60} />
            </Box>
          ) : (
            <Grid container spacing={3}>
              {/* Campaign Performance Overview */}
              <Grid item xs={12}>
                <Card sx={{ p: 3, mb: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                    Campaign Performance Overview
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={6} md={3}>
                      <Box sx={{ textAlign: 'center', p: 2 }}>
                        <Typography variant="h4" color="primary.main" sx={{ fontWeight: 700 }}>
                          {analyticsData.campaignPerformance.totalCampaigns.toLocaleString()}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Total Campaigns
                        </Typography>
                      </Box>
                    </Grid>
                  <Grid item xs={6} md={3}>
                    <Box sx={{ textAlign: 'center', p: 2 }}>
                      <Typography variant="h4" color="success.main" sx={{ fontWeight: 700 }}>
                        {analyticsData.campaignPerformance.averageEngagement}%
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Avg Engagement
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Box sx={{ textAlign: 'center', p: 2 }}>
                      <Typography variant="h4" color="info.main" sx={{ fontWeight: 700 }}>
                        {analyticsData.campaignPerformance.totalNotificationsSent.toLocaleString()}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Notifications Sent
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Box sx={{ textAlign: 'center', p: 2 }}>
                      <Typography variant="h4" color="warning.main" sx={{ fontWeight: 700 }}>
                        ₦{(analyticsData.campaignPerformance.revenueGenerated / 1000000).toFixed(1)}M
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Revenue Generated
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            {/* User Segments */}
            <Grid item xs={12} md={6}>
              <Card sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                  User Segments Performance
                </Typography>
                {analyticsData.userSegments.length > 0 ? (
                  <List>
                    {analyticsData.userSegments.map((segment, index) => (
                      <ListItem key={index} sx={{ borderRadius: 2, mb: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
                        <ListItemIcon>
                          <Avatar sx={{ 
                            bgcolor: index === 0 ? theme.palette.success.main : 
                                     index === 1 ? theme.palette.primary.main :
                                     index === 2 ? theme.palette.warning.main : theme.palette.info.main,
                            width: 32, height: 32
                          }}>
                            <PersonIcon sx={{ fontSize: 16 }} />
                          </Avatar>
                        </ListItemIcon>
                        <ListItemText 
                          primary={segment.name}
                          secondary={`${segment.count.toLocaleString()} users • ${segment.engagement}% engagement`}
                        />
                        <Chip 
                          label={`${segment.engagement}%`} 
                          size="small" 
                          color={segment.engagement > 80 ? 'success' : segment.engagement > 60 ? 'warning' : 'error'}
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No user segments data available
                    </Typography>
                  </Box>
                )}
              </Card>
            </Grid>

            {/* Recent Campaigns */}
            <Grid item xs={12} md={6}>
              <Card sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                  Recent Campaign Performance
                </Typography>
                {analyticsData.recentCampaigns.length > 0 ? (
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Campaign</TableCell>
                          <TableCell align="right">Sent</TableCell>
                          <TableCell align="right">Opened</TableCell>
                          <TableCell align="right">Revenue</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {analyticsData.recentCampaigns.map((campaign) => (
                          <TableRow key={campaign.id}>
                            <TableCell>{campaign.name}</TableCell>
                            <TableCell align="right">{campaign.sent}</TableCell>
                            <TableCell align="right">{campaign.opened}</TableCell>
                            <TableCell align="right">
                              {campaign.revenue > 0 ? `₦${campaign.revenue.toLocaleString()}` : '-'}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No recent campaigns data available
                    </Typography>
                  </Box>
                )}
              </Card>
            </Grid>

            {/* A/B Testing Results */}
            <Grid item xs={12}>
              <Card sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    A/B Testing Results
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => setAbTestData(prev => ({ ...prev, showCreateModal: true }))}
                  >
                    Create New Test
                  </Button>
                </Box>
                {abTestData.activeTests.length > 0 ? (
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Test Name</TableCell>
                          <TableCell>Variant A</TableCell>
                          <TableCell>Variant B</TableCell>
                          <TableCell>Winner</TableCell>
                          <TableCell>Confidence</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {abTestData.activeTests.map((test) => (
                          <TableRow key={test.id}>
                            <TableCell>{test.name}</TableCell>
                            <TableCell>{test.variantA.subject}</TableCell>
                            <TableCell>{test.variantB.subject}</TableCell>
                            <TableCell>
                              <Chip 
                                label={test.winner || 'In Progress'} 
                                color={test.winner ? 'success' : 'warning'}
                                size="small"
                              />
                            </TableCell>
                            <TableCell>{test.confidence || 'N/A'}</TableCell>
                            <TableCell>
                              <IconButton size="small">
                                <VisibilityIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No active A/B tests. Create your first test to optimize campaign performance.
                    </Typography>
                  </Box>
                )}
              </Card>
            </Grid>
          </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAnalyticsModal(false)}>Close</Button>
          <Button variant="contained" startIcon={<DownloadIcon />}>
            Export Report
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbar.severity} 
          sx={{ 
            width: '100%',
            borderRadius: 2,
            boxShadow: theme.shadows[8]
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Custom CSS Animations */}
      <style>
        {`
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
          
          /* Smooth scrolling */
          html {
            scroll-behavior: smooth;
          }
        `}
      </style>
    </Box>
  );
};

export default SmartNotifications; 